module.exports = __webpack_public_path__ + "static/media/icon_jh.8e902469.png";